<template>
  <milestone-wrapper :subscription-period-id="subscriptionPeriodId" :data="data" :meta="meta">
    <template slot="content-completed">
      <GridTable v-if="data.content" :columns="columns" :rows="[data.content]" class="col-12">
        <template #row="{row}">
          <GridTableCell>{{ formatDateTimeForLocale(row.created_at) }}</GridTableCell>
          <GridTableCell>{{ row.description }}</GridTableCell>
        </template>
      </GridTable>
    </template>
  </milestone-wrapper>
</template>

<script>
import MilestoneMixin from '@/mixins/milestone.mixin'
// Components
import MilestoneWrapper from '@/components/milestones/MilestoneWrapper'
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  components: {
    MilestoneWrapper,
    GridTable,
    GridTableCell
  },

  mixins: [MilestoneMixin],

  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },

  computed: {
    columns() {
      return [
        { label: 'Date', width: '150px', align: 'center' },
        { label: 'Description', width: '1fr' }
      ]
    }
  }
}
</script>
